<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Список инженерно-технического персонала, занятого на монтаже здания (сооружения)
    </div>
    <n-divide>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>
    <br>
    <n-table :columns="columns" :data="data" :loading="$var('load')">
      <template #startedAt="{item}">
        {{ $app.date.format(item.startedAt) }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
      <template #endedAt="{item}">
        {{ $app.date.format(item.endedAt) }}
      </template>
    </n-table>
    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import ModalRecord from './record/Index2'
import PageRecordCreate from './Create2'

export default {
  name: 'MainChapter3',
  components: { ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    columns: [
      { name: 'name', title: 'Фамилия, имя отчество', },
      { name: 'class', title: 'Специальность и образование', },
      { name: 'position', title: 'Занимаемая должность', },
      { name: 'startDate', title: 'Дата начала работы на объекте', },
      { name: 'attestation', title: 'Отметка о прохождении аттестации и дата', },
      { name: 'endDate', title: 'Дата окончания работы на объекте', },
      { name: 'tools', title: '', },
    ],
    data: [],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_spec31_records', this.project.id),
      }
    },
  },
  created() {
    this.load()
  },
  methods: {
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    load() {
      this.$var('load', true)
      $api.journals.spec31.two.get(this.project.id).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
